import css from 'styled-jsx/css';

const styles = css`.sign-in{background:#fafafa;display:flex;align-items:center;justify-content:center;min-height:100vh}.sign-in__h1{font-size:1.125rem;line-height:1.25rem;text-align:center}.sign-in__menu{list-style:none;margin:40px 0 0;padding:0}.sign-in__menu li{text-align:center}.sign-in__menu li:not(:last-of-type){margin-bottom:1rem}`;

export default styles;